import React, { Component } from "react";
import { connect } from "react-redux";
import { View, Text, TouchableOpacity } from "react-native";

import { logout } from "state/modules/taker";
import { setFeedbackGroup } from "state/modules/feedback";
import { setupQuestionnaires } from "state/modules/questionnaires";

import { Input, SnackBar, Picker } from "components";
import Layout from "screens/common";

import { styles } from "./styles";
import { styles as qStyles } from "components/question-title/styles";

class Group extends Component {
  state = { showGroupModal: false };

  next = () => {
    this.props.setupQuestionnaires();
    this.props.navigation.navigate("stats");
  };

  render = () => {
    const { feedbackGroups, feedbackGroup, isConnected, logout } = this.props;
    const nextDisabled = !feedbackGroup.id;
    return (
      <>
        <Layout next={this.next} nextDisabled={nextDisabled}>
          <TouchableOpacity style={styles.logout} onLongPress={logout}>
            <Text style={styles.logoutText}>Logout</Text>
          </TouchableOpacity>
          <View style={styles.container}>
            <Text style={[qStyles.questionTextStyle, styles.title]}>
              Select your feedback group
            </Text>
            <TouchableOpacity
              activeOpacity={1}
              disabled={!isConnected}
              onPress={() => this.setState({ showGroupModal: true })}
            >
              <Input
                value={feedbackGroup && feedbackGroup.title}
                placeholder="FEEDBACK GROUP"
                pointerEvents="none"
                fullscreen={false}
                editable={false}
              />
              <Picker
                visible={this.state.showGroupModal}
                options={feedbackGroups}
                textKey="title"
                onPress={this.selectFeedbackGroup}
              />
            </TouchableOpacity>
          </View>
        </Layout>
        {this.renderSnackBar()}
      </>
    );
  };

  selectFeedbackGroup = group => {
    this.setState({ showGroupModal: false });
    this.props.setFeedbackGroup(group);
  };

  renderSnackBar = () => {
    if (this.props.isConnected) return <></>;
    const errorMessage = "Please connect to internet to switch feedback group.";
    return <SnackBar message={errorMessage} />;
  };
}

const mapDispatchToProps = {
  logout,
  setFeedbackGroup,
  setupQuestionnaires,
};

const mapStateToProps = state => {
  return {
    feedbackGroups: state.taker.feedback_groups,
    feedbackGroup: state.feedback.group,
    isConnected: state.network.isConnected,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Group);
